/**
 * One-way redirect to the preview deployment.
 *
 * This code only ever runs on the live stack (the preview stack is a separate
 * deployment/codebase). So we always assume "this is live": when the backend
 * reports the current organisation is on "preview", navigate to the preview host
 * while preserving the current path/query/hash. Only the host changes.
 *
 * The redirect is gated on VUE_APP_PREVIEW_DOMAIN being set, which is only the
 * case on the live production build — local/dev/staging leave it empty, so the
 * feature is inert there. The `currentHost !== previewHost` check is a final
 * loop guard.
 *
 * @param {string} environment - "preview" | "live" returned by the backend.
 * @returns {boolean} true if a redirect was triggered (caller should stop further work).
 */
export function redirectIfPreview(environment) {
  const previewHost = process.env.VUE_APP_PREVIEW_DOMAIN;
  const currentHost = window.location.hostname;

  if (environment === 'preview' && previewHost && currentHost !== previewHost) {
    const { pathname, search, hash } = window.location;
    window.location.replace(`${previewHost}${pathname}${search}${hash}`);
    return true;
  }

  return false;
}
